import { render } from "./BanNer.vue?vue&type=template&id=7a6367f4"
const script = {}

import "./BanNer.vue?vue&type=style&index=0&id=7a6367f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__